module.exports = __webpack_public_path__ + "static/media/mainimage.4907b8dc.jpg";